import 'stylesheets/pages/users/signIn';
import 'stylesheets/pages/users/signUp';
import 'stylesheets/pages/users/confirmation';

import FormInteractiveButton from 'modules/FormInteractiveButton';
import FormPasswordToggle from 'modules/FormPasswordToggle';
import AgrementCheckAlert from 'modules/AgrementCheckAlert';

new FormInteractiveButton();
new FormPasswordToggle();
new AgrementCheckAlert();
